import { useAppSelector } from '../../hooks/useAppSelector'
import { uiVersion } from '../../versions'
import styles from './index.module.scss'
import { selectProducts } from '../../store/selectors/productsSelectors'
import { ProductStatus } from '../../entity/Product'
import { useEffect } from 'react'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import ToolboxWhite from '../../assets/images/Toolbox_white.png'
import { selectInfo } from '../../store/selectors/infoSelectors'
import { fetchInfo } from '../../store/async-thunks/info/fetchInfo'
import { FormattedMessage } from 'react-intl'

export const MainInfo = () => {
    const dispatch = useAppDispatch()
    const info = useAppSelector(selectInfo)
    const { app_version: appVersion } = info
    const products = useAppSelector(selectProducts)

    const activeProductsCount = products.filter(
        (product) => product.status === ProductStatus.ACTIVE
    ).length

    const inactiveProductsCount = products.filter(
        (product) => product.status === ProductStatus.INACTIVE
    ).length

    const idleProductsCount = products.filter(
        (product) => product.status === ProductStatus.IDLE
    ).length

    useEffect(() => {
        dispatch(fetchInfo())
    }, [dispatch])

    return (
        <div className={`${styles.contentBox} d-flex flex-1`}>
            <div
                className={`p-4 flex-1 flex-column`}
                style={{
                    backgroundImage: 'url(' + ToolboxWhite + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                }}
            >
                <h1 className={`${styles.mainTitle} mb-3`}>
                    <FormattedMessage id="homePage.welcome" />
                </h1>
                <div>
                    <FormattedMessage id="homePage.tbUI" />
                    <span>v{uiVersion}</span>
                </div>
                <div className="mb-3">
                    <FormattedMessage id="homePage.tbApp" />
                    <span>v{appVersion}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.active" />
                    <span className="p-active mr-2" />
                    <span className="fw-bold"> {activeProductsCount}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.inactive" />
                    <span className="p-inactive mr-2" />
                    <span className="fw-bold"> {inactiveProductsCount}</span>
                </div>
                <div>
                    <FormattedMessage id="homePage.onStandby" />
                    <span className="p-idle mr-2" />
                    <span className="fw-bold"> {idleProductsCount}</span>
                </div>
            </div>
        </div>
    )
}
